import React from 'react';
import { Linkedin, Instagram, Facebook } from 'lucide-react';
import { companyInfo } from '../data/mockData';

export const SocialIcons = ({ variant = 'light', size = 16 }) => {
  const cls = `social-icon${variant === 'dark' ? ' on-dark' : ''}`;
  return (
    <div className="social-row" data-testid="social-icons">
      <a
        href={companyInfo.social.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn — Swarnava Sengupta"
        className={cls}
        data-testid="social-linkedin"
      >
        <Linkedin size={size} />
      </a>
      <a
        href={companyInfo.social.instagram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram — SS Consultancy"
        className={cls}
        data-testid="social-instagram"
      >
        <Instagram size={size} />
      </a>
      <a
        href={companyInfo.social.facebook}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook — SS Consultancy"
        className={cls}
        data-testid="social-facebook"
      >
        <Facebook size={size} />
      </a>
    </div>
  );
};
